import { render, staticRenderFns } from "./groupFitnessDashboardWarnings.vue?vue&type=template&id=35c65bda&scoped=true"
import script from "./groupFitnessDashboardWarnings.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardWarnings.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardWarnings.vue?vue&type=style&index=0&id=35c65bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c65bda",
  null
  
)

export default component.exports